import { Component } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import "react-phone-input-2/lib/style.css";
import { GET_FORMPOST, GET_DETAILDATA } from "../../actions";
import "./candidate.css";
import api from "../../utils/axios";
import { showAlert, showContaimerLoader, encodeValue, hasPermission } from "../Settings/Settings";

import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Personal from "./module/Personal";
import Discussion from "./module/Discussion";
import Contract from "./module/Contract";
import Documents from "./module/Documents";
import Bank from "./module/Bank";
import Travel from "./module/Travel";
import Medicals from "./module/Medicals";
import Ndk from "./module/Ndk";
import Seaservice from "./module/Seaservice";
import Evaluation from "./module/Evaluation";

const module = "candidate";
const modulePath = "/candidate";
const moduleName = "Candidate";
class Form extends Component {
  constructor(props) {
    super(props);
    const editID = this.props.match.params?.editID ?? "";
    const tabType = this.props.match.params?.tabType ?? "personal";
    
    this.state = {
      editID,
      tabType,
      detaildata: [],
      candidateDetails: "",
      error_msg: "",
      rankList: [],
      experienceList: [],
      countryList: [],
      companyList: [],
      companyListBYID: [],
      vessleTypeList: [],
      portList: [],
      gradeList: [],
      pageloading: false,
      documentExpierd: false,
    };
  }

  componentDidMount() {
    if (this.state.editID !== "") {
      const params = {
        params: "",
        url: `${module}/detail/${encodeValue(this.state.editID)}`,
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
      this.loadDropdown();
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.detaildata !== nextProps.detaildata && nextProps.detaildata !== "" && this.state.editID !== "") {
      this.setState({ detaildata: nextProps.detaildata, pageloading: false }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          const result = nextProps.detaildata[0].result;
          this.setState({ candidateDetails: result });
        } else {
          this.props.history.push(modulePath);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }

  loadDropdown() {
    api
      .get("rank/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ rankList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
    api
      .get("company/dropdownname")
      .then((res) => {
        if (res.data.status === "ok") {
          let result = res.data.result;
          this.setState({ companyList: result });
        }
      })
      .catch((err) => {
        console.error(err);
      });

    api
      .get("company/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          let result = res.data.result;
          this.setState({ companyListBYID: result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
    api
      .get("vesseltype/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          let result = res.data.result;
          this.setState({ vessleTypeList: result });
        }
      })
      .catch((err) => {
        console.error(err);
      });

    api
      .get("port/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          let result = res.data.result;
          this.setState({ portList: result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  sateValChange = (field, value) => {
    if (field === "loadCandidateDetails") {
      const params = {
        params: "",
        url: `${module}/detail/${encodeValue(this.state.editID)}`,
      };
      this.props.getDetailData(params);
    } else if (field === "documentExpierd") {
      this.setState({ documentExpierd: value });
    }
  };

  render() {
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{this.state.editID} | Nemo</title>
        </Helmet>
        <div className="page">
          <div className="page-main">
            <Header currentPage={module} {...this.props} />

            <div className="main-content app-content ">
              <div className="side-app">
                <div className="main-container container-fluid  mx-3">
                  <div className="page-header">
                    <h1 className="page-title">
                      Candidate Id : {this.state.editID} - {this.state.candidateDetails?.fname} {this.state.candidateDetails?.lname}
                    </h1>
                    <div>
                      {(this.state.candidateDetails?.ntbr === "1" || this.state.candidateDetails?.ntbr === 1) && (
                        <span className="badge bg-danger">Not Re-employed by Owners/Clients</span>
                      )}
                      {(this.state.candidateDetails?.ntbr === "0" || this.state.candidateDetails?.ntbr === 0) && (
                        <span className="badge bg-warning">Not Re-employed by Nautilus</span>
                      )}
                    </div>
                  </div>
                  <div className="row" id="modulefrm">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        {this.state.pageloading ? (
                          showContaimerLoader()
                        ) : (
                          <div className="panel panel-primary ">
                            <div className="tab-menu-heading candicate-details">
                              <div className="tabs-menu" style={{background:'#008E9C'}}>
                                <ul className="nav panel-tabs panel-success">
                                  <li>
                                    <a href="#tab1" className={this.state.tabType==='personal'?"active":''} data-bs-toggle="tab">
                                      <span>
                                        <i className="fa fa-user me-1"></i>
                                      </span>
                                      Personal
                                    </a>
                                  </li>
                                  {hasPermission(19, "view") && (
                                    <li>
                                      <a href="#tab2" className={this.state.tabType==='discussion'?"active":''}  data-bs-toggle="tab">
                                        <span>
                                          <i className="fa fa-comments me-1"></i>
                                        </span>
                                        Discussion
                                      </a>
                                    </li>
                                  )}
                                  
                                  {hasPermission(20, "view") && (
                                    <li>
                                      <a href="#tab3" className={this.state.tabType==='contract'?"active":''} data-bs-toggle="tab">
                                        <span>
                                          <i className="fa fa-clipboard me-1"></i>
                                        </span>
                                        Contract
                                      </a>
                                    </li>
                                  )}
                                  {hasPermission(21, "view") && (
                                    <li style={{ borderTop: this.state.documentExpierd?"6px solid red":'' }}>
                                      <a href="#tab4" className={this.state.tabType==='document'?"active":''} data-bs-toggle="tab" style={ { paddingTop: this.state.documentExpierd ?"4px": "" } }>
                                        <span>
                                          <i className="fa fa-file me-1"></i>
                                        </span>
                                        Document
                                      </a>
                                    </li>
                                  )}
                                  {hasPermission(22, "view") && (
                                    <li>
                                      <a href="#tab5" className={this.state.tabType==='bank'?"active":''} data-bs-toggle="tab">
                                        <span>
                                          <i className="fa fa-bank me-1"></i>
                                        </span>
                                        Bank
                                      </a>
                                    </li>
                                  )}
                                  {hasPermission(23, "view") && (
                                    <li>
                                      <a href="#tab6" className={this.state.tabType==='travel'?"active":''} data-bs-toggle="tab">
                                        <span>
                                          <i className="fa fa-plane me-1"></i>
                                        </span>
                                        Travel
                                      </a>
                                    </li>
                                  )}
                                  {hasPermission(24, "view") && (
                                    <li>
                                      <a href="#tab7" className={this.state.tabType==='medical'?"active":''} data-bs-toggle="tab">
                                        <span>
                                          <i className="fa fa-medkit me-1"></i>
                                        </span>
                                        Medical
                                      </a>
                                    </li>
                                  )}
                                  {hasPermission(25, "view") && (
                                    <li>
                                      <a href="#tab8" className={this.state.tabType==='nkd'?"active":''} data-bs-toggle="tab">
                                        <span>
                                          <i className="fa fa-users me-1"></i>
                                        </span>
                                        NKD
                                      </a>
                                    </li>
                                  )}
                                  {hasPermission(26, "view") && (
                                    <li>
                                      <a href="#tab9" className={this.state.tabType==='seaservice'?"active":''} data-bs-toggle="tab">
                                        <span>
                                          <i className="fa fa-anchor me-1"></i>
                                        </span>
                                        Sea Service
                                      </a>
                                    </li>
                                  )}
                                  {hasPermission(27, "view") && (
                                    <li>
                                      <a href="#tab12" className={this.state.tabType==='evaluation'?"active":''} data-bs-toggle="tab">
                                        <span>
                                          <i className="fa fa-line-chart me-1"></i>
                                        </span>
                                        Evaluation
                                      </a>
                                    </li>
                                  )}
                                </ul>
                              </div>
                            </div>
                            <div className="panel-body tabs-menu-body view-details ">
                              <div className="tab-content">
                                <div className={`tab-pane ${this.state.tabType==='personal'?"active":''}`} id="tab1">
                                  <Personal {...this.props} candidateDetails={this.state.candidateDetails} />
                                </div>
                                {hasPermission(19, "view") && (
                                  <div className={`tab-pane ${this.state.tabType==='discussion'?"active":''}`} id="tab2">
                                    <Discussion
                                      {...this.props}
                                      candidateID={this.state.editID}
                                      candidateDetails={this.state.candidateDetails}
                                      rankList={this.state.rankList}
                                      vessleTypeList={this.state.vessleTypeList}
                                      companyList={this.state.companyListBYID}
                                      sateValChange={this.sateValChange}
                                    />
                                  </div>
                                )}
                                {hasPermission(20, "view") && (
                                  <div className={`tab-pane ${this.state.tabType==='contract'?"active":''}`} id="tab3">
                                    <Contract
                                      {...this.props}
                                      candidateID={this.state.editID}
                                      rankList={this.state.rankList}
                                      companyList={this.state.companyListBYID}
                                      vessleTypeList={this.state.vessleTypeList}
                                      portList={this.state.portList}
                                      sateValChange={this.sateValChange}
                                    />
                                  </div>
                                )}
                                {hasPermission(21, "view") && (
                                  <div className={`tab-pane ${this.state.tabType==='document'?"active":''}`} id="tab4">
                                    <Documents {...this.props} candidateID={this.state.editID} sateValChange={this.sateValChange} />
                                  </div>
                                )}
                                {hasPermission(22, "view") && (
                                  <div className={`tab-pane ${this.state.tabType==='bank'?"active":''}`} id="tab5">
                                    <Bank {...this.props} candidateID={this.state.editID} />
                                  </div>
                                )}
                                {hasPermission(23, "view") && (
                                  <div className={`tab-pane ${this.state.tabType==='travel'?"active":''}`} id="tab6">
                                    <Travel {...this.props} candidateID={this.state.editID} />
                                  </div>
                                )}
                                {hasPermission(24, "view") && (
                                  <div className={`tab-pane ${this.state.tabType==='medical'?"active":''}`} id="tab7">
                                    <Medicals {...this.props} candidateID={this.state.editID} />
                                  </div>
                                )}
                                {hasPermission(25, "view") && (
                                  <div className={`tab-pane ${this.state.tabType==='ndk'?"active":''}`} id="tab8">
                                    <Ndk {...this.props} candidateID={this.state.editID} />
                                  </div>
                                )}
                                {hasPermission(26, "view") && (
                                  <div className={`tab-pane ${this.state.tabType==='seaservice'?"active":''}`} id="tab9">
                                    <Seaservice {...this.props} candidateID={this.state.editID} rankList={this.state.rankList} companyList={this.state.companyList} />
                                  </div>
                                )}
                                {hasPermission(27, "view") && (
                                  <div className={`tab-pane ${this.state.tabType==='dvaluation'?"active":''}`} id="tab12">
                                    <Evaluation {...this.props} candidateID={this.state.editID} rankList={this.state.rankList} />
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);
